import { html, svg, type TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { msg } from '@lit/localize';
import { formatRichText } from '../utils/format-richtext.js';

interface BookingRequestConfirmationTemplateParams {
    supportPhone: string;
    onBackClick: (event: Event) => void;
}

const formatPhoneHref = (phoneNumber: string): string => `tel:${phoneNumber.replace(/\s+/g, '')}`;

export const renderBookingRequestConfirmationTemplate = ({
    supportPhone,
    onBackClick,
}: BookingRequestConfirmationTemplateParams): TemplateResult => {
    const systemCheck = (props?: {
        width?: number;
        height?: number;
        viewBox?: string;
        class?: string;
        fill?: string;
    }) => svg`<svg xmlns="http://www.w3.org/2000/svg" width="${props?.width ?? 24}" height="${props?.height ?? 24}" viewBox="${props?.viewBox ?? '-7 -10.5 40 40'}" ${props?.class ? `class="${props.class}"` : ''}>
        <path d="M8.81167 18.6196L0 9.8075L1.5 8.31833L8.81167 15.6304L24.4312 0L25.9312 1.5L8.81167 18.6196Z" fill="${props?.fill ?? '#212121'}"/>
        </svg>`;

    return html`<div class="m-booking-request__confirmation">
        <div class="m-booking-request__confirmation-body">
            <div class="m-booking-request__confirmation-header">
                <div class="m-booking-request__confirmation-icon">${systemCheck({ width: 40, height: 40 })}</div>
                <div class="m-booking-request__confirmation-text-group">
                    <div class="m-booking-request__confirmation-title">
                        ${msg('Herzlichen Dank!', {
                            desc: 'Confirmation headline after form submission',
                        })}
                    </div>
                    <div class="m-booking-request__confirmation-description">
                        ${msg('Ihre Anfrage ist bei uns eingegangen.', {
                            desc: 'Confirmation text that request has been received',
                        })}
                    </div>
                </div>
            </div>

            <div class="m-booking-request__confirmation-footer">
                <div class="m-booking-request__confirmation-description">
                    ${unsafeHTML(
                        formatRichText(
                            msg('Sie erhalten innerhalb von 48 Stunden eine Rückmeldung von uns.', {
                                desc: 'Confirmation text about response time',
                            })
                        )
                    )}
                </div>
                <div class="m-booking-request__confirmation-signature">
                    ${msg('Ihr KUONI Team', {
                        desc: 'Confirmation closing greeting',
                    })}
                </div>
            </div>
        </div>
        <div class="m-booking-request__confirmation-cta">
            <der-ui-button variant="secondary" @click="${onBackClick}">
                ${msg('Zurück zum Angebot', { desc: 'Back link/button text to return to offer' })}
            </der-ui-button>
        </div>
        ${
            supportPhone.trim()
                ? html`<div class="m-booking-request__info-wrapper m-booking-request__contact-support">
                      <der-ui-icon-label icon="systemPhone">
                          <span slot="value">
                              ${msg('Haben Sie Fragen? Kontaktieren Sie unsere Experten unter', {
                                  desc: 'Support contact text prefix below the submit button',
                              })}
                              <a href="${formatPhoneHref(supportPhone)}">${supportPhone}</a>
                          </span>
                      </der-ui-icon-label>
                  </div>`
                : ''
        }
    </div>`;
};
